module.exports = __webpack_public_path__ + "img/ay.cb755e3f.svg";